(() => {
 'use strict';
 const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
 const rail=document.querySelector('.mvx .rail');
 const arrows=[...document.querySelectorAll('.mvx .swipe button')];
 if(rail){
  const sync=()=>{for(const b of arrows)b.disabled=b.dataset.rail==='next'?rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2:rail.scrollLeft<2;};
  for(const b of arrows)b.addEventListener('click',()=>rail.scrollBy({left:(b.dataset.rail==='next'?1:-1)*rail.clientWidth*.85,behavior:motion()}));
  rail.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(rail);sync();
 }
 const main=document.getElementById('mv-gal-main');
 const thumbs=[...document.querySelectorAll('#mv-thumbs button')];
 const comment=document.querySelector('[data-gallery-comment]');
 for(const button of thumbs)button.addEventListener('click',()=>{
  main.src=button.dataset.src;
  const show=button===thumbs[0];comment?.classList.toggle('is-hidden',!show);comment?.setAttribute('aria-hidden',String(!show));
  for(const item of thumbs){item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',String(item===button));}
 });
 // Local preview can exercise choices without posting a test cart to localhost.
 if(location.hostname==='127.0.0.1'||location.hostname==='localhost')document.getElementById('mv-buy-form')?.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();},true);
})();
(() => {
 const track=document.querySelector('.fht-reasons__track');
 if(!track)return;
 const slides=[...track.children],prev=document.querySelector('[data-reason-prev]'),next=document.querySelector('[data-reason-next]'),count=document.querySelector('[data-reason-count]');
 let active=0;
 const sync=()=>{
  const step=slides[0].getBoundingClientRect().width+12;
  active=Math.min(5,Math.round(track.scrollLeft/step));
  count.textContent=`${active+1} / 6`;prev.disabled=active===0;next.disabled=active===5;
 };
 const move=direction=>{
  const target=Math.max(0,Math.min(5,active+direction));
  track.scrollTo({left:target*(slides[0].getBoundingClientRect().width+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 };
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
 track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
 track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();
})();
